import React, { useEffect } from 'react';
import UiKit from '../ui-kit';
import { Trans, useTranslation } from 'react-i18next';
import {
  ExternalNotification,
  LocalNotification,
  NotificationType,
} from '../../infrastructure/types/common/common-types';
import styled from 'styled-components';

interface NotificationManageData<NotificationConfigType> {
  getNotification: () => NotificationConfigType;
  notificationsList: NotificationConfigType[];
}

function useNotifications<
  NotificationConfigType extends ExternalNotification | LocalNotification | undefined,
>(data: NotificationManageData<NotificationConfigType>) {
  const { t } = useTranslation();
  const { showNotification } = UiKit.hooks.useNotification();

  useEffect(() => {
    const notification = data.getNotification();

    notification &&
      showNotification({
        title: t(notification.title as string) as string,
        closable: notification.closable,
        content:
          typeof notification.text === 'string' ? (
            <StyledText>
              <Trans
                i18nKey={notification.text}
                values={{ ...notification.contentLocalizeParams }}
                components={{
                  linkBtn: (
                    <UiKit.Link
                      onClick={() =>
                        notification?.onMessageLinkClick && notification.onMessageLinkClick()
                      }
                    />
                  ),
                  boldText: <UiKit.Text bold={true} />,
                }}
              />
            </StyledText>
          ) : (
            notification.text
          ),
        type: notification.type as NotificationType,
        closeTimeoutSec: notification.closeTimeoutSec,
        footerRender: notification.footerBtnConfig ? (
          <UiKit.Button
            type={notification.footerBtnConfig.type}
            size={'small'}
            onClick={() => notification.footerBtnConfig?.onClick()}
          >
            {t(notification.footerBtnConfig.text)}
          </UiKit.Button>
        ) : (
          <></>
        ),
      });
  }, [t, data.notificationsList.length]);
}

const StyledText = styled(UiKit.P)`
  white-space: pre-line;
`;

export { type NotificationManageData, useNotifications };
